import { ref, isRef } from "vue";
import type { Ref } from "vue";
import type { MaybeRef } from "@/typings/refs";

/**
 * @function getValue - return the ref if defined, if not return a ref of the default value
 * @param {MaybeRef<ValueType>} targetRef - the possible re fto check
 * @param {ValueType} defaultValue - the default value in case the ref is not set correctly
 * @param {boolean|undefined} referenced - the ref returned if exists is the original one not a copy
 * @returns always a ref value, the default or the provided
 */
export default function getValue<ValueType>(
  targetRef: MaybeRef<ValueType>,
  defaultValue: ValueType,
  referenced?: boolean
): Ref<ValueType> {
  //get the parameter referenced
  const isReferenced = referenced ?? true;

  //if the target ref is undefined
  if (targetRef == undefined) {
    //return a ref of the default value
    return ref(defaultValue) as Ref<ValueType>;
  }

  //if it's not a ref then its a non undefined value
  if (!isRef(targetRef)) {
    return ref(targetRef) as Ref<ValueType>;
  }
  //if the target ref value is undefined
  if (targetRef.value == undefined) {
    //if the target is by reference
    if (isReferenced) {
      //change the value to the default
      targetRef.value = defaultValue;
      //return the ref with new value
      return targetRef as Ref<ValueType>;
    } else {
      //return a new ref with the default value
      return ref(defaultValue) as Ref<ValueType>;
    }
    //return a ref of the default value
  }
  //if the target ref value is a value
  else {
    //if its passed by reference(which is the default)
    if (isReferenced) {
      //return the original ref
      return targetRef as Ref<ValueType>;
    } else {
      //return a new ref with the value
      return ref(targetRef.value) as Ref<ValueType>;
    }
  }
}
